import { EntityReferences, ExternalEntityReferences } from "../models/mappers";
import { EntityName, ExternalEntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const onboardingFields = [
  "statecode", // Choice
  "statuscode", // Choice
  "gaming_ContactId", // Lookup - contact
  "gaming_AccountId", // Lookup - account
  "modifiedon", // Date
  "ggp_ggpprogram", // Choice
  "gaming_name", // Text
  "ownerid", // Owner
  "gaming_HubLastUpdateByContactId", // Lookup - contact
  "ggp_middleware_ml", // Multiline text
  "ggp_additionalinfolinks", // Multiline text
  "ggp_taxidnumber", // Text
  "gaming_onboardingid", // UID
  "gaming_onboardingdecision", // Choice
  "gaming_contentvalidationstatus", // Text
  "gaming_onboardinghubcreated", // Boolean
  "ggp_fasttrack", // Choice - YesNo
  "gaming_OnboardingHubProfileId", // Lookup - onboarding hub profile
  "gaming_submitteddate", // Date
  "ggp_xdkagreementreceived", // Date
] as const;

export const onboardingReferences: EntityReferences<EntityName.gaming_onboarding> = {
  [EntityName.account]: ["gaming_AccountId"],
  [EntityName.contact]: ["gaming_ContactId", "gaming_HubLastUpdateByContactId"],
  [EntityName.gaming_onboardinghubprofile]: ["gaming_OnboardingHubProfileId"],
};

export const onboardingExternalReferences: ExternalEntityReferences<EntityName.gaming_onboarding> =
  {
    [ExternalEntityName.team]: ["ownerid"],
  };

export const onboardingKey: AnyEntityField<EntityName.gaming_onboarding> = "gaming_onboardingid";
